import dayjs from 'dayjs';
import { ALL_DAY } from './constants';
import { DateType } from './types';

export const setDayType = (date: dayjs.Dayjs) => {
  let localDay = date.toDate().toLocaleDateString();

  let day = ALL_DAY.find((x) => x.day === localDay);
  switch (day?.type) {
    case DateType.WorkDay:
      day.type = DateType.Weekend;
      break;

    case DateType.Weekend:
      day.type = DateType.DayOff;
      break;

    case DateType.DayOff:
      day.type = DateType.WorkDay;
      break;
  }
};
